import { createContext } from 'react';

import { noop } from '@/utils/noop';

type UnderlinedTabsContextState = {
  activeTab: number;
  setActiveTab: (activeTab: number) => void;
};

export const Context = createContext<UnderlinedTabsContextState>({
  activeTab: 0,
  setActiveTab: noop,
});
